import React, { Component } from "react";
import { Link } from "react-router-dom";
import { CameraFeed } from "./camera-feed";
import ComputerFeed from "./computer-feed";
import GameInit from "./game-init";

class PlayGround extends Component {
  state = {};
  ref = React.createRef();
  ref1 = React.createRef();

  takePhotoAgain = () => {
    setTimeout(() => {
      this.ref.current.takePhoto();
    }, 4000);
    this.ref1.current.callAnime();
  };

  render() {
    return (
      <React.Fragment>
        <div className="play-ground">
          <div className="flex-1">
            <h3>{this.props.name !== "" ? this.props.name : "Player"}</h3>
            <div className="score">{this.props.playerScore}</div>
            <CameraFeed
              sendFile={this.props.uploadImage}
              onCamInit={this.props.onCamInit}
              ref={this.ref}
            />
          </div>
          <div className="mid-container">
            <div className="wrap-div">
              {this.props.camInit !== false ? (
                <GameInit
                  index={this.props.index}
                  onInc={this.props.onInc}
                  imageUrl={this.props.imageUrl}
                  onImgLoad={this.props.onImgLoad}
                ></GameInit>
              ) : null}
            </div>
          </div>
          <div className="flex-2">
            <h3>Computer</h3>
            <div className="score">{this.props.computerScore}</div>
            <div className="computerAgent">
              {this.props.camInit !== false ? (
                <ComputerFeed
                  random={this.props.random}
                  ref={this.ref1}
                ></ComputerFeed>
              ) : null}
            </div>
          </div>
        </div>
        <div className="Next-round">
          {this.props.imageUrl !== "" ? (
            <div>
              <button className="next-button" onClick={this.props.onNext}>
                Next
              </button>
              <Link to="/">
                <button
                  className="quit-button"
                  onClick={() => {
                    document.body.style.backgroundImage =
                      "url('/static/media/bg1.597f3428.png'),linear-gradient(180deg, #390f01, #000)";
                    this.props.onQuit();
                  }}
                >
                  Quit
                </button>
              </Link>
            </div>
          ) : null}
        </div>
      </React.Fragment>
    );
  }
}

export default PlayGround;
